<h1><a href="/admin-home">Admin</a> - International Subscription Requests</h1>

<section>
  <p>Status: <select id="filterStatus" (change)="getRequests()" [(ngModel)]="selectedStatus">
      @for (s of statuses; track s) {
        <option [value]="s.id">
          {{s.name}}
        </option>
      }
    </select>
  </p>
  <table class="data">
    <thead><tr><td>Username</td><td>Licenses Requested</td><td></td><td></td><td></td></tr></thead>
    <tbody>
      @for (row of report; track row) {
        <tr>
          <td>{{row.username}}</td>
          <td class="number">{{row.license_qty_requested}}</td>
          <td>{{f.dateFormat(row.request_date)}}</td>
          <td><button *ngIf="approvalButton(row.status)">{{approvalButton(row.status)}}</button></td>
          <td><button *ngIf="denyButton(row.status)">{{denyButton(row.status)}}</button></td>
        </tr>
      }
    </tbody>
  </table>
</section>
